module.exports = __webpack_public_path__ + "static/media/document.bb909bff.svg";